import { HomepageHeaderArenaBadgeDefaultBox } from "./home-page-header-arena-badge.default.box";

export const HomepageHeaderArenaBadgeBox = HomepageHeaderArenaBadgeDefaultBox;
